import { metricKeys } from '@pulse/metrics';
import update from 'immutability-helper';
import * as types from './types';

export const StreamsTabKey = 'streams';
export const DevicesTabKey = 'devices';
export const ViewersTabKey = 'viewers';
// Ad-Content SPI section is always visible
// but it's treated like a tab to reuse existing code
export const AdContentTabKey = 'adContent';

export const MessageConfig = {
  [StreamsTabKey]: {
    metrics: [
      metricKeys.BadSession,
      metricKeys.BadSessionPct,
      metricKeys.GoodSessionAverageLifePlayingTimeMins,
      metricKeys.BadSessionAverageLifePlayingTimeMins,
    ],
    granularity: 'ALL',
  },
  [DevicesTabKey]: {
    metrics: [
      metricKeys.BadUniqueDevices,
      metricKeys.GoodUniqueDevices,
    ],
    granularity: 'PT1H',
  },
  [ViewersTabKey]: {
    metrics: [
      metricKeys.BadUniqueViewers,
      metricKeys.GoodUniqueViewers,
    ],
    granularity: 'PT1H',
  },
}

const initialState = {
  activeTab: StreamsTabKey,
  [StreamsTabKey]: {
    response: null,
    isFetching: true,
    errorCode: 0,
    errorMsg: '',
  },
  [DevicesTabKey]: {
    response: null,
    isFetching: true,
    errorCode: 0,
    errorMsg: '',
  },
  [AdContentTabKey]: {
    response: null,
    isFetching: true,
    errorCode: 0,
    errorMsg: '',
  },
  [ViewersTabKey]: {
    response: null,
    isFetching: true,
    errorCode: 0,
    errorMsg: '',
  },
}

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_RESPONSE] = (state, action) => {
  const { tabKey, response, errorMsg } = action;
  return update(state, {
    [tabKey]: {
      $merge: {
        response,
        isFetching: false,
        errorCode: 0,
        errorMsg,
      },
    },
  });
}

switchMap[types.SET_LOADING_STATE] = (state, action) => {
  const { tabKey, loadingState } = action;
  return update(state, {
    [tabKey]: {
      isFetching: { $set: loadingState },
    },
  });
}

switchMap[types.SET_ACTIVE_TAB] = (state, action) => {
  const { tabKey } = action;
  return update(state, {
    activeTab: { $set : tabKey}
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
